import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  header: {
    description: 'International settings header',
    defaultMessage: 'International Settings',
    id: 'nTEt+W',
  },
  customs: {
    description: 'International settings customs subheader',
    defaultMessage: 'Default Customs Information',
    id: 'zokJDo',
  },
  tracking: {
    description: 'International settings Tracking subheader',
    defaultMessage: 'Tracking',
    id: '+3dqKX',
  },
  pageDescription: {
    description: 'International settings page description',
    defaultMessage:
      'ShipStation can automatically assign a default setting for your customs information for every order that is imported with an international destination. You can always change this setting on individual orders as well.',
    id: '/hqkPW',
  },
  itnInfoNote: {
    description: 'International settings AES ITN info note',
    defaultMessage:
      'This setting will apply to USPS, FedEx, UPS and international shipments containing commercial invoices. Your Tax ID will be encrypted and will not display in the ShipStation interface.',
    id: 'fHs4nS',
  },
  uspsInfoNote: {
    description: 'International settings AES USPS info note',
    defaultMessage: 'This setting will apply to USPS shipments only.',
    id: 'SOAZB0',
  },
  uspsCodePlaceholder: {
    description: 'International settings AES USPS exemption code dropdown placeholder',
    defaultMessage: 'Select code',
    id: '8AOnrn',
  },
  uspsLearnMore: {
    description: 'International settings AES USPS learn more button label',
    defaultMessage: 'Learn More',
    id: 'VMYDzh',
  },
  vatNote: {
    description: 'International settings VAT note',
    defaultMessage: '<b>Note</b>: Your VAT Registration Number will be applied to your Commercial Invoices for international shipments.',
    id: 'niRzFz',
  },
  encrypted: {
    description: 'International settings ITN encrypted placeholder',
    defaultMessage: '(Encrypted)',
    id: 'hHf36r',
  },
  nonTrackableHover: {
    description: 'Hovertext for non-trackable checkbox',
    defaultMessage:
      'Some international shipments do not provide valid tracking numbers; however, you can opt out using the labels\' "reference number" as a tracking number. This is generally recommended only for marketplaces that require a tracking number for every shipment.',
    id: 'MZo+EL',
  },
  taxIdentifiers: {
    description: 'Tax identifier section heading',
    defaultMessage: 'Tax Identifiers',
    id: 'e+EkhQ',
  },
  addATaxIdentifier: {
    description: 'Tax identifier add another tax id',
    defaultMessage: 'Add a Tax Identifier',
    id: 'EkClL0',
  },
  addTaxIdentifierButton: {
    description: 'Tax identifier add another tax id',
    defaultMessage: 'Add Tax Identifier',
    id: 'PphPxt',
  },
  optional: {
    description: 'Optional Tax identifier field',
    defaultMessage: '(Optional)',
    id: 'y7xYty',
  },
  delete: {
    description: 'Delete Tax identifier row',
    defaultMessage: 'Delete',
    id: 'scJQh9',
  },
  deleteHeader: {
    description: 'Ship From delete modal header',
    defaultMessage: 'Delete Tax Identifier',
    id: 'LnEhb4',
  },
  iorLabel: {
    description: 'Importer of Record label for international settings page',
    defaultMessage: 'Importer of Record',
    id: 'DLt1Ez',
  },
  addIOR: {
    description: 'Add Importer of Record button in IOR section',
    defaultMessage: 'Add Importer of Record',
    id: 'Eud5+T',
  },
  addIORModalTitle: {
    description: 'Add Importer of Record modal title',
    defaultMessage: 'Importer of Record',
    id: 'yWmLaT',
  },
  cancelAddIOR: {
    description: 'Cancel button for Add Importer of Record modal',
    defaultMessage: 'Cancel',
    id: '+b4YQu',
  },
  iorNameField: {
    description: 'Importer of Record name field',
    defaultMessage: 'IOR Name',
    id: 'W7VIg2',
  },
  iorAddressField: {
    description: 'Importer of Record address field',
    defaultMessage: 'IOR Address',
    id: 'JJElP3',
  },
  deleteIORModalHeader: {
    description: 'Delete Importer of Record modal header',
    defaultMessage: 'Delete Importer of Record',
    id: 'Anp/lq',
  },
  confirmIORDeleteMessage: {
    description: 'Delete Importer of Record confirmation message',
    defaultMessage: 'Are you sure you want to delete this Importer of Record?',
    id: 'ZUqW7/',
  },
  confirmMessage: {
    description: 'Ship From delete modal text',
    defaultMessage: 'Are you sure you want to delete this Tax Identifier?',
    id: '0zpkB5',
  },
  cancel: {
    description: 'Cancel button',
    defaultMessage: 'Cancel',
    id: 'qz9XeG',
  },
  uniqueNickname: {
    description: 'Nickname must be unique error message',
    defaultMessage: 'Nickname must be unique',
    id: 'hxiNwM',
  },
  addError: {
    description: 'Unknown error occurred while adding tax identifier',
    defaultMessage: 'An unknown error has occurred while trying to save your tax identifier. Please try again.',
    id: 'z73M1a',
  },
  billDutiesAndTaxesToPayor: {
    description: 'International settings Duties & Taxes subheader',
    defaultMessage: 'Duties & Taxes',
    id: 'h14D68',
  },
  companyMinLengthError: {
    description: 'Company name minimum length error message',
    defaultMessage: 'Company must be at least 2 characters',
    id: 'HyknXA',
  },
  customsStoreCurrency: {
    description: 'International settings checkbox label for using store currency on customs form',
    defaultMessage: 'Apply order import currency to customs declarations',
    id: 'OODlRf',
  },
  customsStoreCurrencyTooltip: {
    description: 'Tooltip for customs store currency checkbox',
    defaultMessage:
      'When enabled, the currency from your order source will be applied to customs declarations for all applicable orders. Note: not all carriers support currencies other than your home country currency.',
    id: '2UYNrR',
  },
  blankCountryOption: {
    description: 'Blank option for country of origin dropdown in international settings',
    defaultMessage: ' ',
    id: 'FHwV8c',
  },
  customsDescription: {
    description: 'International settings customs tab description',
    defaultMessage:
      'These settings apply automatically to the customs paperwork for every international order you import. Change any of them on an individual order as needed.',
    id: 'gbR0WE',
  },
  aesTitle: {
    description: 'International settings AES card title',
    defaultMessage: 'Automated Export System (AES)',
    id: 'luBfVp',
  },
  aesLearnMore: {
    description: 'International settings AES card learn more link',
    defaultMessage: 'Learn more',
    id: 'gJYuZs',
  },
  aesDoNotUse: {
    description: 'International settings AES option, do not use',
    defaultMessage: 'Do not use',
    id: 'IFf6M7',
  },
  aesUseItn: {
    description: 'International settings AES option, use ITN',
    defaultMessage: 'Use ITN/Tax ID',
    id: 'TGS8ts',
  },
  aesUseExemption: {
    description: 'International settings AES option, use USPS exemption code',
    defaultMessage: 'Use USPS exemption code',
    id: 'uYHtGY',
  },
  taxIdentifiersDescription: {
    description: 'International settings tax identifiers tab description',
    defaultMessage: 'Add tax ID numbers needed to clear international orders, like VAT or EORI.',
    id: 'K4pAjU',
  },
  taxIdType: {
    description: 'International settings tax identifiers table column, tax ID type',
    defaultMessage: 'Tax ID Type',
    id: 'PrYgK4',
  },
  noTaxIdentifiers: {
    description: 'International settings tax identifiers empty table row',
    defaultMessage: 'No tax identifiers added yet.',
    id: 'VqKM2i',
  },
  iorDescription: {
    description: 'International settings importer of record tab description',
    defaultMessage:
      'Add the business or individual responsible for compliance and for paying duties and taxes in the destination country, when one is required.',
    id: 'xROz6r',
  },
  noIors: {
    description: 'International settings importer of record empty table row',
    defaultMessage: 'No importers of record added yet.',
    id: 'mjiwVs',
  },
  dutiesTitle: {
    description: 'International settings duties and taxes card title',
    defaultMessage: 'Select the default method for international labels',
    id: 'RgDGIK',
  },
  dutiesDescription: {
    description: 'International settings duties and taxes card description',
    defaultMessage: 'We recommend DDP to help customers avoid surprise delivery fees. You can override this for any shipment.',
    id: 'woHK3B',
  },
  dutiesLearnMore: {
    description: 'International settings duties and taxes card learn more link',
    defaultMessage: 'Learn more about International Shipping.',
    id: 'ibRsaz',
  },
  ddpTitle: {
    description: 'International settings DDP option title',
    defaultMessage: 'Delivered Duty Paid (DDP)',
    id: '7oJeYJ',
  },
  ddpDescription: {
    description: 'International settings DDP option description',
    defaultMessage: 'You pay duties and taxes as the shipper.',
    id: 'u3xOju',
  },
  dduTitle: {
    description: 'International settings DDU option title',
    defaultMessage: 'Delivered Duty Unpaid (DDU)',
    id: '9NJZ/y',
  },
  dduDescription: {
    description: 'International settings DDU option description',
    defaultMessage: 'Customer pays duties and taxes upon delivery.',
    id: 'xroob2',
  },
  recommended: {
    description: 'International settings recommended badge on the DDP option',
    defaultMessage: 'Recommended',
    id: 'lbimmf',
  },
  dduWarning: {
    description: 'International settings warning shown when DDU is selected',
    defaultMessage:
      'The recipient will be responsible for paying duties and taxes when the shipment arrives. We recommend informing them in advance to avoid delivery delays.',
    id: 't4Z18T',
  },
  unsavedChangesTitle: {
    description: 'International settings unsaved changes modal title',
    defaultMessage: 'Unsaved changes',
    id: '7BTxvR',
  },
  unsavedChangesContent: {
    description: 'International settings unsaved changes modal content',
    defaultMessage: 'You have unsaved changes on this page. If you leave now, your changes will be lost.',
    id: 'd3bBKU',
  },
  unsavedChangesCancelButton: {
    description: 'International settings unsaved changes modal cancel button, stays on the page',
    defaultMessage: 'Stay on page',
    id: 'M+7Sah',
  },
  unsavedChangesContinueButton: {
    description: 'International settings unsaved changes modal continue button, discards changes and leaves',
    defaultMessage: 'Leave without saving',
    id: 'jTPkuK',
  },
});
